import React from 'react';
import classNames from './NoClasses.module.scss';
import classes from 'classnames';
import SVG from 'react-inlinesvg';

import hat from '@/assets/svg/hat-unfill.svg';
import { useTranslation } from 'react-i18next';
import TheButton from '../TheButton/TheButton';
import AppLoaderCircle from '../AppLoaderCircle';

interface NoClassesProps {
  className?: string;
  loading?: boolean;
  isGoogle?: boolean;
  isMGWebsite?: boolean;
  isClassCode?: boolean;
  emitCreateClass: () => void;
  googleCreateClass: () => void;
  setIsClassEdit?: React.Dispatch<React.SetStateAction<boolean>>;
}

const NoClasses = ({
  className,
  emitCreateClass,
  loading,
  isGoogle = false,
  isMGWebsite = false,
  isClassCode = false,
  googleCreateClass,
  setIsClassEdit,
}: NoClassesProps) => {
  const { t } = useTranslation();

  const createClassText = isGoogle ? t('importClasses') : t('createClass');

  const onCreateClass = () => {
    emitCreateClass();
    if (setIsClassEdit) {
      setIsClassEdit(true);
    }
  };

  return (
    <div className={classes(classNames.noClasses, className)}>
      {loading ? (
        <>
          <AppLoaderCircle className='m-auto' />
        </>
      ) : (
        <>
          <SVG className={classNames.hat} src={hat} />
          {!isMGWebsite && <span className={classNames.createClassText}>{createClassText}</span>}
          <h2>
            {isMGWebsite
              ? t('noClasses')
              : isGoogle
                ? t('importYourFirstClass')
                : isClassCode
                  ? t('createYourFirstClass')
                  : `${t('createYourFirstClass')} ${t('andInviteYourStudents')}!`}
          </h2>
          <div className={classNames.description}>
            {isMGWebsite
              ? t('noStudentMistake')
              : isGoogle
                ? t('importYourFirstClassDescription')
                : isClassCode
                  ? t('setupYourClass')
                  : t('createYourFirstClassDescription')}
          </div>
          {!isMGWebsite && (
            <TheButton
              className={classNames.createClassBtn}
              text={createClassText}
              shouldRecolor={false}
              emitOnClick={isGoogle ? googleCreateClass : onCreateClass}
            />
          )}
        </>
      )}
    </div>
  );
};

export default NoClasses;
